import 'reflect-metadata'
import {Address} from './Address'
import {joinWhereDefined} from '@peachy/utility-kit-pure'
import {Type} from 'class-transformer'

export class Pharmacy {

    @Type(() => Address)
    readonly address: Address

    constructor(readonly id: string | undefined,
                readonly name: string,
                address: Address,
                readonly nhsOrganisationId?: string) {
        this.address = address
    }

    toFormattedString(separator: string = '\n') {
        return joinWhereDefined(separator,
            this.name,
            this.address.toFormattedString(separator)
        )
    }
}